import handleRelianceIPAChangeHelper from "./relianceIPAHelper/handleRelianceIPAChangeHelper";

export const handleChangeHelper = (event, productName, formik) => {
  if (productName === "Reliance IPA") {
    handleRelianceIPAChangeHelper(event, formik);
  }
};

export const handleOnBlurHelper = () => {
  // Add your logic for onBlur if needed
};
